import Accordion from './components/Accordion'
import ContactForm from './components/ContactForm'
import DownloadButton from './components/DownloadButton'
import Tabs, { Tab } from 'shared/components/Tabs'
import TextBlock from './components/TextBlock'
import Subscribe from 'home/components/Subscribe'
import CustomForm from './components/CustomForm'

const layoutToComponent = layout => {
    const map = {
        accordion: Accordion,
        download_button: DownloadButton,
        contact_form: ContactForm,
        tabs: props => <Tabs {...props} tabStyle="pills" />,
        tab: Tab,
        text: TextBlock,
        subscribe: Subscribe,
        custom_form: CustomForm,
    }

    return map[layout] || null
}

const contentToComponents = post => {
    const { layout = '', content = null } = post

    const hasChildren = Array.isArray(content) && content.length > 0
    const Element = layoutToComponent(layout)

    if (Element) {
        if (hasChildren)
            return <Element {...post}>{content.map((c, i) => contentToComponents({ ...c, key: i }))}</Element>

        return <Element {...post} />
    }

    return null
}

export default contentToComponents
